import React from 'react';

import EditIcon from '@mui/icons-material/Edit';
import LockIcon from '@mui/icons-material/Lock';
import { Box, Button, IconButton } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import * as actions from '../actions';

const renderOptions = ({
    disabled,
    handleClickUpdate,
    isOwner,
    row,
    t,
} = {}) => {
    if (!isOwner)
        return (
            <IconButton
                disabled={disabled}
                onClick={() => handleClickUpdate(row)}
                size="small"
            >
                <EditIcon fontSize="small" />
            </IconButton>
        );

    return (
        <Button
            startIcon={<LockIcon />}
            onClick={() => handleClickUpdate(row)}
            variant="text"
        >
            {t('View user')}
        </Button>
    );
};

const ActionsFormatter = ({ handleClickUpdate, row }) => {
    const { t } = useTranslation();
    const { type } = row;
    const isOwner = parseInt(type) === 0;

    return (
        <Box
            sx={{
                alignItems: 'center',
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'end',
                gap: '4px',
                width: '100%',
            }}
        >
            {renderOptions({
                handleClickUpdate,
                isOwner,
                row,
                t,
            })}
        </Box>
    );
};

const mapDispatchToProps = (dispatch) => ({
    handleClickUpdate: (item) => dispatch(actions.prepareUpdate(item)),
});

ActionsFormatter.propTypes = {
    handleClickUpdate: PropTypes.func,
    row: PropTypes.object,
};

export default compose(connect(null, mapDispatchToProps))(ActionsFormatter);
